import HBIcon from "@/components/HBIcon";
import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import Pay from "@/components/Pay";
import { getGoods, orderCalculate } from "@/services";
import { getAdaptiveImg } from "@/utils/imageUrl";
import useRequest from "@/utils/useReq";
import { getSkusByCode, getSkuUnit } from "../shared/utils";
import styles from "./index.module.less";

function RawPayRetentionModal({ config, onOk, ...props }) {
  const { data } = useRequest(async () => {
    const res = await getGoods({
      ids: config.goodIds,
    });

    const skus = getSkusByCode(res.list, config.goodCodes);

    const payParam = {
      scene: "normal",
      skus: skus.map((sku) => {
        return {
          sku_id: sku.id,
          quantity: 1,
          is_upgrade: false,
        };
      }),
      promotion: {
        user_coupon_ids: [],
      },
    };

    if (config.activity) {
      payParam.promotion.activities = [
        {
          id: config.activity,
        },
      ];
    }
    // 计算订单金额与原价
    const orderPre = await orderCalculate(payParam);
    const originPrice = skus.reduce((pre, cur) => pre + cur?.original_price, 0);

    return {
      skus,
      price: orderPre.actual_total_price,
      originPrice:
        originPrice > orderPre.actual_total_price ? originPrice : null,
      payParam,
      // 时间单位
      unit: getSkuUnit(skus[0]),
    };
  });

  const back = getAdaptiveImg(
    "https://st0.dancf.com/static/02/202209090413-e837.png",
    {
      width: 664,
    }
  );

  if (data && data.skus.length) {
    return (
      <HBModal
        className={styles.payRetention}
        footer={null}
        width={664}
        {...props}
      >
        <div
          className={styles.body}
          style={{ backgroundImage: `url(${back})` }}
        >
          <div className={styles.title}>{config.title}</div>
          <div className={styles.card}>
            <div className={styles.left}>
              <h2>{config.name}</h2>
              <div className={styles.price}>
                ¥<span>{data.price}</span>
                <span>/{data.unit}</span>
                {data.originPrice && (
                  <span>
                    ￥{data.originPrice}/{data.unit}
                  </span>
                )}
              </div>
              <ul>
                {config.desc.map((info, index) => (
                  <li key={index}>
                    <HBIcon type="ic_check_circle" />
                    <span
                      dangerouslySetInnerHTML={{ __html: info.text }}
                    ></span>
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.right}>
              <div>扫码立即开通</div>
              <div className={styles.price}>¥{data.price}</div>
              <Pay
                skuParam={data.payParam}
                padding={0}
                size={100}
                style={{ boxShadow: "none" }}
                onDone={onOk}
                data-gd-expose="pay_expose"
                data-order-type={`支付挽留_${config.name}`}
              />

              <div className={styles.payText}>
                <HBIcon
                  className={styles.payIcon}
                  type="a-icon-wechatpay"
                  style={{
                    color: "#59CC0D",
                  }}
                />
                <HBIcon
                  className={styles.payIcon}
                  type="a-icon-alipay"
                  style={{
                    color: "#06B4FD",
                  }}
                />
                扫码支付
              </div>
              <div className={styles.agreement}>
                支付即同意
                <a
                  href="/about/disclaimer?activeKey=2"
                  target="_blank"
                  rel="noreferrer"
                >
                  《花瓣素材会员服务协议》
                </a>
                和
                <a
                  href="/about/disclaimer?activeKey=6"
                  target="_blank"
                  rel="noreferrer"
                >
                  《花瓣个人会员授权许可协议》
                </a>
              </div>
            </div>
          </div>
        </div>
      </HBModal>
    );
  }

  return null;
}

const PayRetentionModal = ModalWrap(RawPayRetentionModal);

export default PayRetentionModal;
